import React from 'react'
import PropTypes from 'prop-types'
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward'
import css from './location.css'

const ContactInfoMap = ({ forwardingInfo, officeInfo }) => (
  <div className={css.mappings}>
    <div className={css.data}>{forwardingInfo || 'n/a'}</div>
    <div className={css.arrow}>
      <ArrowForwardIcon />
    </div>
    <div className={css.data}>{officeInfo}</div>
  </div>
)

ContactInfoMap.propTypes = {
  forwardingInfo: PropTypes.string,
  officeInfo: PropTypes.string,
}

export default ContactInfoMap



// WEBPACK FOOTER //
// ./src/components/Account/ContactInfoMap.js